export const surveyConfigServer = {
    baseURL: 'https://consumer-report-config-api.steady.darvis.dev',
    consumerReportBaseURL: 'https://report.dailyvanity.com'
  }